import { render, staticRenderFns } from "./tipsreporthistorydetail.vue?vue&type=template&id=2d91b2da&scoped=true"
import script from "./tipsreporthistorydetail.vue?vue&type=script&lang=js"
export * from "./tipsreporthistorydetail.vue?vue&type=script&lang=js"
import style0 from "./tipsreporthistorydetail.vue?vue&type=style&index=0&id=2d91b2da&prod&lang=scss&scoped=true"
import style1 from "./tipsreporthistorydetail.vue?vue&type=style&index=1&id=2d91b2da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91b2da",
  null
  
)

export default component.exports